//引入pinia
import { createPinia } from "pinia";
//引入持久化插件 https://prazdevs.github.io/pinia-plugin-persistedstate/zh/guide/
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
//创建pinia实例
const pinia= createPinia();
//将插件添加到 pinia 实例上
pinia.use(piniaPluginPersistedstate);

export default pinia